<div class = "row my-row pt-5 pb-5">
    <!-- Titre de la page -->
    <div class="col-xl-12 my-col">
      <h1>{{ "SETTINGS.FOLDERS.TITLE" | translate }}</h1>
    </div>
    
    <div class='container-fluid my-container'>
        <div class='row my-row'>
            <div class='col-11 my-col'>
                <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
            </div>
        </div>

        <div class='row my-row'>
            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SETTINGS.FOLDERS.MODAL-TITLE" | translate }}
                    </div>
                    <div class='card-body'>
                        <div class='container-fluid my-container'>
                            <div class='row row-cols-1 my-row'>
                                <div class='col my-col'>
                                    <ng-container *ngFor="let folder of this.folders; let folderIndex = index">
                                        <div *ngIf="folder.type != 'draft' && folder.type != 'trash'">
                                            <h4 *ngIf="folder.type == 'sending'">{{ 'MESSAGES.FOLDER-SENDING' | translate }}</h4>
                                            <h4 *ngIf="folder.type == 'draft'">{{ 'MESSAGES.FOLDER-DRAFT' | translate }}</h4>
                                            <h4 *ngIf="folder.type == 'trash'">{{ 'MESSAGES.FOLDER-TRASH' | translate }}</h4>
                                            <h4 *ngIf="folder.type == 'receive'">{{ 'MESSAGES.FOLDER-RECEIVE' | translate }}</h4>
                                            <ul>
                                                <ng-container *ngFor="let subfolder of folder.children">
                                                    <li class="mx-2 my-2">
                                                        <div class="row my-row">
                                                            <div class="col my-col">
                                                                <span>{{subfolder.title}}</span>
                                                            </div>
                                                            <div class="col my-col">
                                                                <button type="button" class="btn btn-danger btn-sm mx-1" (click)="deleteFolder(folderIndex, subfolder)">{{ "BUTTONS.DELETE" | translate }}</button>
                                                                <button type="button" class="btn btn-primary btn-sm mx-1" (click)="updateFolder(subfolder)">{{ "BUTTONS.UPDATE" | translate }}</button>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                            <form class="form-inline my-2" novalidate="novalidate" (submit)="addFolder(folderIndex, folder, newFolderName.value)">
                                                <div class="form-group">
                                                    <input #newFolderName type="text" class="form-control" style="display: inline;" id="newSubfolder" placeholder="{{ 'SETTINGS.FOLDERS.NEW-FOLDER' | translate }}">
                                                    <button type="submit" class="btn btn-primary mx-2">{{ "BUTTONS.ADD" | translate }}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                      </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</div>